import { IsString, MaxLength } from 'class-validator';

export class PricelistItemSearchDTO {

    @IsString()
    @MaxLength(50)
    name: string;

}
